document.addEventListener('DOMContentLoaded', () => {
    MicroModal.init({
        disableScroll: true,
        awaitCloseAnimation: true,
    });
});

class ProductCustomizer extends HTMLElement {
    constructor() {
        super();

        this.id = this.getAttribute('id');

        // Canvas options
        this.options = {
            width: 900,
            height: 801,
        };

        // All used selectors
        this.selectors = {
            parent: this.closest('section'),
            canvas: this.querySelector('canvas'),
            imagesAction: this.querySelectorAll('[data-change-image]'),

            removeObject: this.querySelector('[data-remove-object]'),

            input: this.querySelector('[data-input-text]'),
            inputBtn: this.querySelector('[data-input-btn]'),
            inputColor: this.querySelector('[data-color]'),
            inputError: this.querySelector('[data-input-error]'),

            imageInput: this.querySelector('#customizer_image'),
            imageLabel: this.querySelector('[for="customizer_image"]'),

            fontLink: this.querySelector('#fontLink'),
            fontListToggle: this.querySelector('[data-toggle]'),
            fontChangeBtns: this.querySelectorAll('[data-change-font] button'),

            masterId: this.querySelector('[name="id"]'),
            form: this.querySelector('form'),
            submit: this.querySelector('[type="submit"]')
        };

        // Temp data
        this.temp = {
            variant: window.productPreviewImages[0],
            currentVariantImageIndex: 0,
            font: this.selectors.fontChangeBtns[0].textContent,
            color: this.selectors.inputColor.value,
            imageCount: 1
        };

        this._bindEvents();

        this._initPreview(window.productPreviewImages[0].previewImage[0]);
    }

    _updateCanvasButtons() {
        // Update buttons
        this.temp.currentVariantImageIndex === 0
            ? this.selectors.imagesAction[0].setAttribute('disabled', 'disabled')
            : this.selectors.imagesAction[0].removeAttribute('disabled');

        this.temp.currentVariantImageIndex === (this.temp.variant.previewImage.length - 1)
            ? this.selectors.imagesAction[1].setAttribute('disabled', 'disabled')
            : this.selectors.imagesAction[1].removeAttribute('disabled');
    }

    _changeImageHandle(arg) {
        if (arg === 'prev') {
            this.temp.currentVariantImageIndex -= 1;
        } else {
            this.temp.currentVariantImageIndex += 1;
        }

        this._updateCanvasButtons();

        this._updateCanvasBg(this.temp.variant.previewImage[this.temp.currentVariantImageIndex]);
    }

    _updateCanvasBg(imgUrl) {
        if (imgUrl === '#' && window.productPreviewImagesDefault !== '') {
            imgUrl = window.productPreviewImagesDefault;
        }

        this.canvas.setBackgroundImage(imgUrl, () => {
            this.canvas.renderAll();
        }, {
            width: this.options.width,
            height: this.options.height,
            originX: 'left',
            originY: 'top',
            crossOrigin: 'anonymous'
        });
    }

    _initPreview(imgUrl) {
        function selectionChange() {
            let activeElement = this.canvas.getActiveObject();
            this.selectors.removeObject.classList.remove('d-none');
            activeElement.type === 'i-text'
                ? (this.selectors.input.value = activeElement.text)
                    && (this.selectors.inputBtn.classList.add('customizer__btn--reverse'))
                : null;
        }

        this.canvas = new fabric.Canvas(this.selectors.canvas);
        this.canvas.on({
            'selection:created': selectionChange.bind(this),
            'selection:updated': selectionChange.bind(this),
            'selection:cleared': () => {
                this.selectors.input.value = '';
                this.selectors.removeObject.classList.add('d-none');
                this.selectors.inputBtn.classList.remove('customizer__btn--reverse')
            }
        });
        this.canvas.setDimensions({width: this.options.width, height: this.options.height});

        this._updateCanvasButtons();
        this._updateCanvasBg(imgUrl);
    }

    _bindEvents() {
        // Textarea | Editing text
        this.selectors.input.addEventListener('input', (e) => {
            this._changeText(e.target.value);
        });
        // Textarea | Color change
        this.selectors.inputColor.addEventListener('input', (e) => {
            this._changeColor(e.target.value);
        });

        this.selectors.imagesAction.forEach(btn => {
           btn.addEventListener('click', () => {
              this._changeImageHandle(btn.dataset.changeImage);
           });
        });

        // Remove Active Object
        this.selectors.removeObject.addEventListener('click', () => {
            let activeElement = this.canvas.getActiveObject();
            if (activeElement.type === 'image')
                document.querySelector(`[name="${activeElement.cacheKey}"]`).remove();
            this.canvas.remove(activeElement);
        });

        // Add text btn
        this.selectors.inputBtn.addEventListener('click', this._addText.bind(this));

        // Mobile font list toggle
        this.selectors.fontListToggle.addEventListener('click', () => {
            this.selectors.fontListToggle.parentElement.classList.toggle('expanded');
        });
        // Change font | Buttons
        this.selectors.fontChangeBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                if (btn.classList.contains('active')) return;

                this._changeFont(btn.textContent);
                btn.closest('ul').querySelector('.active').classList.remove('active');
                btn.classList.add('active');
            })
        });

        // Image Upload
        this.selectors.imageInput.addEventListener('change', (e) => {
            this._uploadImageHandle(e);
        });

        // Mater ID update - change Preview image
        this.selectors.masterId.addEventListener('change', (e) => {
            this.temp.variant = window.productPreviewImages.find((item) => {
                return item.id === e.target.value;
            });
            this.temp.currentVariantImageIndex = 0;
            this._updateCanvasButtons();
            this._updateCanvasBg(this.temp.variant.previewImage[0]);
        });

        // Form Submit
        this.selectors.submit.addEventListener('click', this._submitHandle.bind(this));

        // Font onload event | Canvas - set font
        document.fonts.onloadingdone = () => {
            let activeElement = this.canvas.getActiveObject();

            if (activeElement === undefined || activeElement === null) return;
            activeElement.set("fontFamily", this.temp.font);
            this.canvas.renderAll();
        };

        // Show customizer on section select in Theme Editor
        document.addEventListener("shopify:section:select", (e) => {
            let parentId = this.selectors.parent.getAttribute('id');
            parentId = parentId.replace('shopify-section-', '');

            if (parentId === e.detail.sectionId) {
                this._showCustomizer();
            }
        });
        // Hide customizer on section deselect in Theme Editor
        document.addEventListener("shopify:section:deselect", (e) => {
            let parentId = this.selectors.parent.getAttribute('id');
            parentId = parentId.replace('shopify-section-', '');

            if (parentId === e.detail.sectionId) {
                this._closeCustomizer();
            }
        });
    }

    _transformText(input) {
        return input.toUpperCase();
    }

    _showCustomizer() {
        MicroModal.show(this.id);
    }
    _closeCustomizer() {
        MicroModal.close(this.id);
    }
    _uploadImageHandle(e) {
        let files = e.target.files,
            fileReader = new FileReader();

        fileReader.onload = (e) => {

            // Get images proportions
            let image = new Image();
            image.src = e.target.result;
            image.onload = (e) => {
                let calcScale = 350 / image.width;

                // Insert image
                fabric.Image.fromURL(fileReader.result, (img) => {
                    this.canvas.add(img).setActiveObject(img).renderAll();
                }, {
                    left: 0,
                    top: 0,
                    scaleX: calcScale,
                    scaleY: calcScale,
                    padding: 10
                });

                // Recreate new input when first
                // file input received a file
                this.selectors.imageInput.removeAttribute('id');
                this.temp.imageCount += 1;
                let newInput = document.createElement('input');
                newInput.type = 'file';
                newInput.accept = 'image/png, image/jpeg';
                newInput.name = `texture${this.temp.imageCount}`;
                newInput.id = 'customizer_image';
                this.selectors.form.append(newInput);

                // Update selectors & binds
                this.selectors.imageInput = this.querySelector('#customizer_image');
                this.selectors.imageInput.addEventListener('change', (e) => {
                    this._uploadImageHandle(e);
                });
            };
        };

        fileReader.readAsDataURL(files[0]);
    };

    _changeFont(font) {
        // Mobile select wrapper
        document.querySelector('.customizer__font-mobile').classList.remove('expanded');
        this.temp.font = font;
        this.selectors.fontLink.href = `https://fonts.googleapis.com/css2?family=${font.replace(' ', '+')}`;
    }

    _changeText(text) {
        if (text.length >= 16) {
            this.selectors.input.value = this.selectors.input.value.substring(0, 16);
            this.selectors.inputError.classList.remove('d-none');
        } else {
            this.selectors.inputError.classList.add('d-none');
        }

        let activeElement = this.canvas.getActiveObject();

        if (activeElement === undefined || activeElement === null) return;


        activeElement.text = this._transformText(this.selectors.input.value);
        this.canvas.renderAll();
    }

    _changeColor(color) {
        this.temp.color = color;

        let activeElement = this.canvas.getActiveObject();

        if (activeElement === undefined || activeElement === null) return;
        if(activeElement.type !== 'i-text') return;

        activeElement.set({fill: this.temp.color});

        this.canvas.renderAll();
    }

    _addText() {
        let textSize = Number(document.querySelector('.customizer__text__area').getAttribute('data-size'))

        let text = this._transformText(this.selectors.input.value);
        let canvasText = new fabric.IText(text, {
            left: this.options.width / 2,
            top: this.options.height / 2,
            fontSize: textSize,
            fontFamily: this.temp.font,
            fill: this.temp.color,
            hasControls: false,
            editable: false
        });

        // Focus text to make is editable
        this.canvas.add(canvasText).setActiveObject(canvasText);
    }

    _submitHandle(e) {
        e.preventDefault();
        this.canvas.discardActiveObject().renderAll();
        let parentForm = this.selectors.form;
        // Get text data from all the canvas objects
        // images data were created OnLoad.
        this.canvas.getObjects().forEach((e, index) => {
            let customIndex = ++index;
            if (e.type === 'i-text') {
                let inputText = document.createElement('input');
                inputText.name = `properties[Text ${customIndex}:]`;
                inputText.value = e.text;

                let inputFont = document.createElement('input');
                inputFont.name = `properties[Text ${customIndex} font family:]`;
                inputFont.value = e.fontFamily;

                let inputColor = document.createElement('input');
                inputColor.name = `properties[Text ${customIndex} color:]`;
                inputColor.value = e.fill;

                parentForm.append(inputText, inputFont, inputColor);
            }
        });

        this.selectors.form.querySelectorAll('[type="file"]').forEach((input, index) => {
           input.setAttribute('name', `properties[Image_${++index}]`);
        });

        let inputPreview = document.createElement('input');
        let container = new DataTransfer();
        inputPreview.type = 'file';
        inputPreview.name = `properties[Preview:]`;

        this.selectors.canvas.toBlob((blob) => {
            let file = new File([blob], "preview.jpg",{type:"image/jpeg", lastModified:new Date().getTime()});
            container.items.add(file);
            inputPreview.files = container.files;
            parentForm.append(inputPreview);

            this.selectors.submit.classList.add('customizer__btn--reverse');
            parentForm.submit();
        });
    }
}

customElements.define('product-customizer', ProductCustomizer);